// The invoice always covers vacation pay, employer tax and pension, regardless
// of whether those costs are included in the entered gross salary.
export function calculateSalaryAmounts(inputAmount: number, mode: string, vacationMode: string,
  pensionMode: string, pensionRate: number, employerTaxRate: number, feeRate: number) {
  const includedVacation = vacationMode === 'included' ? 0.12 : 0;
  const includedPension = pensionMode === 'deduct' ? 1.12 * pensionRate * 1.2426 : 0;
  const requestedGross = inputAmount / (1 + includedVacation + includedPension);
  const requestedGrossWithVacation = requestedGross * 1.12;
  const requestedPension = Math.round(requestedGrossWithVacation * pensionRate);
  let invoiceAmount = mode === 'gross'
    ? requestedGrossWithVacation * (1 + employerTaxRate) + Math.round(requestedPension * 1.2426)
    : inputAmount;
  if (mode === 'invoice' && (vacationMode !== 'included' || (pensionMode !== 'deduct' && pensionRate > 0))) {
    const includedCosts = (1 + employerTaxRate) * (1 + includedVacation) + includedPension;
    const baseGross = (inputAmount - Math.round(inputAmount * feeRate)) / includedCosts;
    const baseGrossWithVacation = baseGross * 1.12;
    const addedPension = Math.round(baseGrossWithVacation * pensionRate);
    const salaryCost = baseGrossWithVacation * (1 + employerTaxRate) + Math.round(addedPension * 1.2426);
    invoiceAmount = salaryCost + Math.round(salaryCost * feeRate / (1 - feeRate));
  }
  const availableAmount = invoiceAmount - Math.round(invoiceAmount * feeRate);
  const pensionBasis = availableAmount / (1 + employerTaxRate + pensionRate * 1.2426);
  const pension = Math.round(pensionBasis * pensionRate);
  const pensionTotal = Math.round(pension * 1.2426);
  // Keep the existing whole-krona pension rounding, then balance the actual
  // salary against the remaining funds instead of adding costs a second time.
  const grossWithVacation = (availableAmount - pensionTotal) / (1 + employerTaxRate);
  const gross = grossWithVacation / 1.12;
  return { invoiceAmount, gross, grossWithVacation, pension, pensionTotal,
    vacationAmount: grossWithVacation - gross, employerTax: grossWithVacation * employerTaxRate };
}
